var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.4139 12.0001L17.7068 7.70721C18.0977 7.31622 18.0977 6.68424 17.7068 6.29324C17.3158 5.90225 16.6838 5.90225 16.2928 6.29324L12 10.5862L7.70718 6.29324C7.3162 5.90225 6.68422 5.90225 6.29324 6.29324C5.90225 6.68424 5.90225 7.31622 6.29324 7.70721L10.5861 12.0001L6.29324 16.293C5.90225 16.684 5.90225 17.316 6.29324 17.707C6.48823 17.902 6.74422 18 7.00021 18C7.2562 18 7.51219 17.902 7.70718 17.707L12 13.4141L16.2928 17.707C16.4878 17.902 16.7438 18 16.9998 18C17.2558 18 17.5118 17.902 17.7068 17.707C18.0977 17.316 18.0977 16.684 17.7068 16.293L13.4139 12.0001Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
